import React, { useEffect, useState } from "react";
import { fetchFeatured999 } from "../api";
import ProductGrid from "../../products/components/ProductGrid";
import ProductGridSkeleton from "../../products/components/ProductGridSkeleton";
import HomeSection from "./HomeSection";

const Products999 = ({ onLoaded }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const pageSize = 30;

  const fetchProducts = async (page = 0) => {
    setLoading(true);
    let loaded = [];
    try {
      const data = await fetchFeatured999(page, pageSize);
      loaded = data?.publicProducts?.content || [];
      setProducts(loaded);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
      onLoaded?.(loaded.length);
    }
  };

  useEffect(() => {
    fetchProducts(0);
  }, []);

  if (loading) return <ProductGridSkeleton count={6} variant="row" />;
  // An empty home section is hidden rather than shown as "No products found".
  if (products.length === 0) return null;

  return (
    <>
      <HomeSection
        title="✨999"
        subtitle="Everything at 999"
        action={{ label: "Shop all products", to: "/products" }}
      >
        <ProductGrid products={products} showLoadmore={false} bare variant="row" />
      </HomeSection>
     
    </>
  );
};

export default Products999;